// src/App.js
import React from "react";
import {  HashRouter as Router,Route, Routes, Navigate } from "react-router-dom"; // Import routing components
import { AuthProvider } from "../src/components/AuthContext"; // Import the AuthProvider
import Login from "./components/login"; // Your Login component
import AdminPanel from "./components/adminPanel"; // AdminPanel component
import StaffPanel from "./components/staffPanel"; // StaffPanel component
import UserPanel from "./components/userPanel"; // UserPanel component
import MyBookingPage from "./pages/mybookingPage";
import Appointment from "./pages/appointment";
import Service from "./pages/service";
import Staff from "./pages/staff";
import StaffPayment from "./pages/staffPayment";
import Embeded from "./pages/embeded";
import SettingCompany from "./pages/settingCompany";
import Crm from "./pages/crm";
import Appearance from "./pages/appearance";
import Addpricing from "./pages/addpricing";
import Seo from "./pages/seo";
import Quickbook from "./pages/quickbook";
import Xero from "./pages/xero";
import SettingPayment from "./pages/settingPayment";
import EmailNotification from "./pages/emailNotification";
import Recurrence from "./pages/recurrence";
import Addons from './pages/addons';
import Schedule from './pages/schedule';
import Payment from './pages/payment';
import Referal from './pages/referral';
import Promocode from './pages/promocode';
import Smstemplate from './pages/smsTemplate';
import Genral from './pages/genral';
import Addstaff from './pages/addStaff';
import EmailTemplate from './pages/emailTemplate';
import StaffPaymentDetails from './pages/staffPaymentDetails';
import RecurrenceDetail from "./pages/recurrenceDetail";
import Fronttooltip from "./pages/fronttooltip";
import Smsnotification from "./pages/smsnotification";
import Export from './pages/export';
import Label from './pages/label';
import AdminProfile from "./pages/adminProfile";
import ManageableForm from './pages/manageableForm';
import Customerinformation from './pages/customerInformation';
import ServiceInformation from './pages/serviceInformation';
import AddUnit from './pages/addunit';
import SchedulePage_s from "./pages/schedule_s";
import Payment_s from "./pages/payment_s";
import StaffProfile from "./pages/staffProfile";
import UserProfile from "./pages/userProfile";
import Booking from "./pages/booking";
import Appoinment_s from "./pages/userAppointment";
import GuestCustomer from "./pages/guestcustomer";    
import Emlsms from "./pages/emlsms";
import Edit from "./pages/editCustomer";
import AdminDashboard from "./components/AdminDashboard"; 
import StaffDashboard from "./components/StaffDashboard"; 
import UserDashboard from "./components/UserDashboard"; 
import "./App.css";
import ResetPassword from "./pages/ResetPassword";

// RequireAuth component to protect routes based on user role
function RequireAuth({ children, allowedRole }) {
  // const userType = localStorage.getItem('userType');
  // const userId = localStorage.getItem('userId');

  
  const userType = sessionStorage.getItem('userType');
  const userId = sessionStorage.getItem('userId');
  
  
  if (!userType || !userId) {
    // User is not logged in, redirect to login page
    return <Navigate to="/login" replace />;
  }
  
  if (allowedRole && userType !== allowedRole) {
    // User doesn't have the required role, redirect to their dashboard
    return <Navigate to={`/${userType}`} replace />;
  }
  
  // User is authenticated and has the correct role
  return children;
}

function App() {
  
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<MyBookingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* Admin Routes */}
          <Route path="/admin/*" element={
            <RequireAuth allowedRole="admin">
              <AdminPanel />
            </RequireAuth>
          }>
            <Route path="" element={<AdminDashboard />} />
            <Route path="appointment" element={<Appointment />} />
            <Route path="service" element={<Service />} />
            <Route path="staff" element={<Staff />} />
            <Route path="embeded" element={<Embeded />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="setting" element={<SettingCompany />} />
            <Route path="export" element={<Export />} />
            <Route path="editcustomer/:id"element={<Edit/>} />

            <Route path="payment" element={<Payment />} />
            <Route path="adminProfile" element={<AdminProfile />} />
            <Route path="export/customerInformation" element={<Customerinformation />} />
            <Route path="export/serviceInformation" element={<ServiceInformation />} />
            <Route path="payment/staffPaymentDetails" element={<StaffPaymentDetails />} />
            <Route path="payment/recurrenceDetail" element={<RecurrenceDetail />} />
            <Route path="service/pricing" element={<Addpricing />} />
            <Route path="service/addons" element={<Addons />} />
            <Route path="service/pricing/addunit" element={<AddUnit />} />
            <Route path="setting/seo" element={<Seo />} />
            <Route path="setting/appearance" element={<Appearance />} />
            <Route path="setting/quickbook" element={<Quickbook />} />
            <Route path="setting/xero" element={<Xero />} />
            <Route path="setting/emailNotification" element={<EmailNotification />} />
            <Route path="setting/referral" element={<Referal />} />
            <Route path="setting/promocode" element={<Promocode />} />
            <Route path="setting/genral" element={<Genral />} />
            <Route path="setting/smsTemplate" element={<Smstemplate />} />  
            <Route path="setting/payment" element={<SettingPayment />} />
            <Route path="setting/recurrence" element={<Recurrence />} />
            <Route path="staff/staffPayment" element={<StaffPayment />} />
            <Route path="setting/emailTemplate" element={<EmailTemplate />} />
            <Route path="setting/fronttooltip" element={<Fronttooltip />} />
            <Route path="setting/label" element={<Label />} />  
            <Route path="setting/manageableForm" element={<ManageableForm />} />
            <Route path="setting/smsnotification" element={<Smsnotification />} />
            <Route path="staff/addStaff" element={<Addstaff />} />
            <Route path="crm" element={<Crm />} />
            <Route path="crm/emlsms" element={<Emlsms/>} />
            <Route path="crm/guestcustomer"element={<GuestCustomer/>} />          
          </Route>

          {/* Staff Routes */}
          <Route path="/staff/*" element={
              <RequireAuth allowedRole="staff">
                <StaffPanel/>
              </RequireAuth>
          }>
              <Route path="" element={<StaffDashboard/>} />
              {/* Other staff-specific routes */}
              <Route path="schedule_s" element={<SchedulePage_s/>} />
              <Route path="staffProfile" element={<StaffProfile/>} />
              <Route path="booking" element={<Booking/>} />
              <Route path="payment_s" element={<Payment_s/>} />
          </Route>

          {/* User Routes */}
          <Route path="/user/*" element={
              <RequireAuth allowedRole="client">
                <UserPanel/>
              </RequireAuth>
          }>
              <Route path="" element={<UserDashboard/>} />
              {/* Other user-specific routes */}
              
              <Route path="userProfile" element={<UserProfile/>} />
              <Route path="appoinment_s" element={<Appoinment_s/>} />        
          </Route>

          {/* Redirect for unknown routes */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

export const BaseUrl = process.env.REACT_APP_API_URL;
// console.log("Base URL:", BaseUrl);



// import React from "react";
// import { Route, Routes, BrowserRouter as Router } from "react-router-dom"; // Import routing components
// import Login from "./components/login"; // Your Login component
// import AdminPanel from "./components/adminPanel"; // AdminPanel component
// import StaffPanel from "./components/staffPanel"; // StaffPanel component
// import UserPanel from "./components/userPanel"; // UserPanel component
// import MyBookingPage from "./pages/mybookingPage";
// import Appointment from "./pages/appointment";
// import Service from "./pages/service";
// import Staff from "./pages/staff";
// import StaffPayment from "./pages/staffPayment";
// import Embeded from "./pages/embeded";
// import SettingCompany from "./pages/settingCompany";
// import Crm from "./pages/crm";
// import Appearance from "./pages/appearance";
// import Addpricing from "./pages/addpricing";
// import Seo from "./pages/seo";
// import Quickbook from "./pages/quickbook";
// import Xero from "./pages/xero";
// import SettingPayment from "./pages/settingPayment";
// import EmailNotification from "./pages/emailNotification";
// import Recurrence from "./pages/recurrence";
// import Addons from './pages/addons';
// import Schedule from './pages/schedule';
// import Payment from './pages/payment';
// import Referal from './pages/referral';
// import Promocode from './pages/promocode';
// import Smstemplate from './pages/smsTemplate';
// import Genral from './pages/genral';
// import Addstaff from './pages/addStaff';
// import EmailTemplate from './pages/emailTemplate';
// import StaffPaymentDetails from './pages/staffPaymentDetails';
// import RecurrenceDetail from "./pages/recurrenceDetail";
// import Fronttooltip from "./pages/fronttooltip";
// import Smsnotification from "./pages/smsnotification";
// import Export from './pages/export';
// import Label from './pages/label';
// import AdminProfile from "./pages/adminProfile";
// import ManageableForm from './pages/manageableForm';
// import Customerinformation from './pages/customerInformation';
// import ServiceInformation from './pages/serviceInformation';
// import AddUnit from './pages/addunit';
// import SchedulePage_s from "./pages/schedule_s";
// import Payment_s from "./pages/payment_s";
// import StaffProfile from "./pages/staffProfile";
// import UserProfile from "./pages/userProfile";
// import Booking from "./pages/booking";
// import Appoinment_s from "./pages/appoinment_s";
// import GuestCustomer from "./pages/guestcustomer";    
// import Emlsms from "./pages/emlsms";
// import "./App.css";
// import Edit from "./pages/editCustomer";
// import AdminDashboard from "./components/AdminDashboard";
// import StaffDashboard from "./components/StaffDashboard";
// import UserDashboard from "./components/UserDashboard";
// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Define your routes here */}
//         <Route path="/" element={<MyBookingPage />} />
        
//         <Route path="/login" element={<Login/>} />
//         {/* <Route path="/pricing" element={<Addpricing/>}/> */}

//         <Route path="/admin" element={<AdminPanel />}>
       
//         <Route path="" element={<AdminDashboard />} />
        
//            <Route path="appointment" element={<Appointment />} />
//           <Route path="service" element={<Service />} />
//           <Route path="staff" element={<Staff />} />
//           <Route path="embeded" element={<Embeded />} />
//           <Route path="schedule" element={<Schedule />} />
//           <Route path="setting" element={<SettingCompany />} />
//           <Route path="export" element={<Export />} />
//           <Route path="payment" element={<Payment />} />
//           <Route path="adminProfile" element={<AdminProfile/>}/>
//           <Route path="export/customerInformation" element={<Customerinformation/>}/>
//           <Route path="export/serviceInformation" element={<ServiceInformation />}/>
//           <Route path="payment/staffPaymentDetails" element={<StaffPaymentDetails />} />
//           <Route path="payment/recurrenceDetail" element={<RecurrenceDetail />} />
//           <Route path="service/pricing" element={<Addpricing />} />
//           <Route path="service/addons" element={<Addons />} />
//           <Route path="service/pricing/addunit" element={<AddUnit />} />
//           <Route path="setting/seo" element={<Seo />} />
//           <Route path="setting/appearance" element={<Appearance />} />
//           <Route path="setting/quickbook" element={<Quickbook />} />
//           <Route path="setting/xero" element={<Xero />} />
//           <Route path="setting/emailNotification" element={<EmailNotification />} />
//           <Route path="setting/referral" element={<Referal />} />
//           <Route path="setting/promocode" element={<Promocode />} />
//           <Route path="setting/genral" element={<Genral />} />
//           <Route path="setting/smsTemplate" element={<Smstemplate />} />  
//           <Route path="setting/payment" element={<SettingPayment />} />
//           <Route path="setting/recurrence" element={<Recurrence />} />
//           <Route path="staff/staffPayment" element={<StaffPayment/>}/>
//           <Route path="setting/emailTemplate" element={<EmailTemplate />}/>
//           <Route path="setting/fronttooltip" element={<Fronttooltip />} />
//           <Route path="setting/label" element={<Label />} />  
//           <Route path="setting/manageableForm" element={<ManageableForm />} />
//           <Route path="setting/smsnotification" element={<Smsnotification />} />
//           <Route path="staff/addStaff" element={<Addstaff/>} />
//           <Route path="crm" element={<Crm />} />
//           <Route path="crm/editcustomer/:id"element={<Edit/>}/>
//           <Route path="crm/emlsms" element={<Emlsms/>}/>
//           <Route path="crm/guestcustomer"element={<GuestCustomer/>}/>
          
//           <Route path="appointment/editcustomer/:id" element={<Edit />} />
//         </Route>
//         <Route path="/staff" element={<StaffPanel/>}>
//         <Route path="" element={<StaffDashboard/>}/>

//         {/* <Route path="staffdash" element={<StaffDashboard/>}/> */}


//           <Route path="schedule_s" element={<SchedulePage_s/>}/>
//           <Route path="staffProfile" element={<StaffProfile/>}/>
//           <Route path="booking" element={<Booking/>}/>
//           <Route path="payment_s" element={<Payment_s/>}/>
//         </Route>
//         <Route path="/user" element={<UserPanel />}>
//         <Route path="" element={<UserDashboard/>}/>

//           <Route path="userProfile" element={<UserProfile/>}/>
//           <Route path="appoinment_s" element={<Appoinment_s/>}/>
        
//         </Route>
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// export const BaseUrl = process.env.REACT_APP_API_URL;
// console.log("helllllllllllllllllllllllllllll",BaseUrl)